import React from "react";
import ReactHtmlParser from "react-html-parser";
import { MInput, MSelect, ValidatedForm } from "components/forms";

import {
  payloadBuilder,
  notNullObjectBuilder,
  enrollmentService,
  networkErrorHelper,
} from "libs";

import { Row } from "design-react-kit";

export class EnrollFillAdesioniSostegnoTriennalisti extends ValidatedForm {
  PAYLOADS = {
    schoolTypes: [
      { value: "", label: "Selezionare" },
      { value: "Infanzia", label: "scuola dell’infanzia" },
      { value: "Primaria", label: "scuola primaria" },
      {
        value: "Secondaria di primo grado",
        label: "scuola secondaria di I grado",
      },
      {
        value: "Secondaria di secondo grado",
        label: "scuola secondaria di II grado",
      },
    ],
  };

  FIELDS_GROUP = [
    [
      {
        field: "schoolType",
        label: "Selezionare il Grado di interesse ",
        payload: { options: this.PAYLOADS.schoolTypes },
        component: MSelect,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "durata",
        field: "durata",
        label:
          "Numero anni di servizio sul sostegno negli ultimi 5 anni cioè dal 01 Settembre 2020",
        infoText:
          "Numero anni di servizio sul sostegno negli ultimi 5 anni cioè dal 01 Settembre 2020",
        component: MInput,
        type: "number",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "presso",
        field: "presso",
        label: "Regione di svolgimento della prova finale",
        infoText: "Indicare la Regione di svolgimento della prova finale",
        component: MInput,
        className: "col-md-6",
      },
    ],
  ];

  ERROR_MESSAGES = {
    schoolType: "Valore obbligatorio",
    durata: "Valore obbligatorio",
    presso: "Valore obbligatorio",
  };

  validation = {
    durata: (value) =>
      value !== "" && parseInt(value) > 0 && parseInt(value) < 6,
    schoolType: (value) => value > "",
    presso: (value) => value > "",
  };

  emptyFields = {
    schoolType: "",
    durata: "",
    presso: "",
  };

  state = {
    loading: true,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
  };

  constructor(props) {
    super(props);

    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  getPayload = () => {
    const formPayload = payloadBuilder(this.state);

    const payloadQualification = [];
    payloadQualification.push({
      qualificationType: "AbilitazioneSostegnoTriennalisti",
      template: "AbilitazioneSostegnoTriennalisti",
      schoolType: formPayload.schoolType,
      durata: formPayload.durata,
      presso: formPayload.presso,
    });

    return payloadQualification;
  };

  loadRemote(additionalState = {}) {
    const defaultValues = notNullObjectBuilder(this.emptyFields, {
      document: this.props.enrollData.idEnrollment,
    });

    const newState = {
      defaultValues,
      loading: false,
      ...additionalState,
    };

    this.setState(newState);
  }

  onSubmit = async () => {
    let validationSummary = "";
    let isValid = false;
    let isValidProfile = true;

    this.payload = payloadBuilder(this.state);
    let isValidForm = this.checkValidation();

    if (!isValidForm) {
      validationSummary += "<li>Inserire i campi obbligatori in rosso</li>";
    }

    // if valid call saveRemote: send data to server
    isValid = isValidProfile && isValidForm;

    if (isValid) {
      const payloadQualification = {
        idEnrollment: this.props.enrollData.idEnrollment,
        qualifications: this.getPayload(),
        currentStep: this.props.enrollData.currentStep,
      };

      try {
        // attendo la chiamata remota
        await enrollmentService.updateEnrollmentQualification(
          payloadQualification
        );
      } catch (errors) {
        validationSummary +=
          "<li>Errore imprevisto nell'invio dei dati. Se il problema persiste contattare il supporto tecnico.</li>";
        networkErrorHelper.notify(errors);
        isValid = false;
      }
    }

    // set state with validation summary
    if (validationSummary !== "") {
      validationSummary = "<ul>" + validationSummary + "</ul>";
    }
    this.setState({ validationSummary: validationSummary });

    return isValid;
  };

  saveRemote = () => {
    const validations = {
      schoolType: null,
      durata: null,
      presso: null,
    };

    this.setState({ formActive: false, ...validations });
  };

  render() {
    const { loading, defaultValues, validationSummary } = this.state;

    if (loading) return <></>;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        <div>
          <form>{code}</form>
        </div>

        <Row>
          <div className="w-100">
            {validationSummary && (
              <div className="alert alert-danger mt-3" role="alert">
                {ReactHtmlParser(validationSummary)}
              </div>
            )}
          </div>
        </Row>
      </>
    );
  }
}
